<template>
    <div class="mobile-nav grid" :class="rootClasses">
        <!-- <pre v-text="partials.menu"></pre> -->

        <div class="mobile-nav--header" :class="[scrollLockIosFixClasses]" :style="scrollLockStyles">
            <div class="mobile-nav--wrapper" :class="[isPhone ? 'mobile-nav--wrapper__is-phone' : '']">
                <div class="mobile-nav--row">
                    <div class="mobile-nav--col">
                        <button class="mobile-nav--menu-btn" @click.prevent="requestMobileNav">
                            <div class="mobile-nav--icon mobile-nav-btn" :class="mobileNavBtnClasses">
                                <span v-for="n in 3" class="mobile-nav-btn--bar"></span>
                            </div>
                        </button>
                        <router-link :to="homeTree.path" :title="homeTree.label" class="mobile-nav--logo-btn">
                            <img class="mobile-nav--logo" :src="'img/sib_logo.svg' | static">
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="mobile-nav--list" :class="[scrollLockIosFixClasses]">
            <transition name="trs-toggle-mobile-nav"
                    @enter="onScrollLockEnterHook"
                    @afterLeave="onScrollLockAfterLeaveHook">
                <cmp-mobile-nav-list class="mobile-nav--list-root"
                        v-if="mobileNavigation.isOpen"
                        :menu="homeTree.children" :meta="meta">
                </cmp-mobile-nav-list>
            </transition>
        </div>
    </div>
</template>

<script>
    import { get } from 'lodash';
    import { mapActions, mapGetters } from 'vuex';
    import { toNumeral, numerals } from 'util/dom/mq';
    import bemMixin from 'vue/mixins/bem';
    import scrollLockHelperMixin from 'vue/mixins/scroll-lock-helper';


    export default {
        mixins: [
            bemMixin('mobile-nav'),
            scrollLockHelperMixin,
        ],
        computed: {
            ...mapGetters(['viewport', 'partials', 'mobileNavigation', 'scroll', 'navTheme']),
            rootClasses() {
                return [
                    this.bemAdd(this.navTheme),
                    this.bemIf(this.scroll.progress < 0.01, 'is-at-top'),
                ];
            },
            mobileNavBtnClasses() {
                return [
                    this.mobileNavigation.isOpen ? 'mobile-nav-btn__is-open' : '',
                ];
            },
            menu() {
                return get(this, 'partials.menu.content.menu', []);
            },
            meta() {
                return get(this, 'partials.meta', []);
            },
            homeTree() {
                return this.menu[0] || {};
            },
            isPhone() {
                return toNumeral(this.viewport.mq.query) < numerals.SM;
            },
        },
        methods: {
            ...mapActions(['toggleMobileNavigation']),
            requestMobileNav() {
                this.toggleMobileNavigation({ isOpen: !this.mobileNavigation.isOpen });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?123198ac